export default "__VITE_ASSET__C88S0pLj__"